import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ObjectListHeaderToggleButton } from "@/sx-layout/components/plotmap/components/objectList/components/ObjectListHeaderToggleButton";

type Props = {
  isOpen: boolean;
  onToggleList: () => void;
  target: "machine" | "other";
  onChangeTarget: (_: "machine" | "other") => void;
  machineStatus: "all" | "inOperation" | "waiting";
  onFilterMachineStatus: (_: "all" | "inOperation" | "waiting") => void;
};

export const ObjectListHeader: FC<Props> = ({
  isOpen,
  onToggleList,
  target,
  onChangeTarget,
  machineStatus,
  onFilterMachineStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center space-x-8 text-[13px] h-[40px]">
      <h3 className="my-10 font-bold text-[14px]">{t("object_list")}</h3>
      <button onClick={onToggleList}>
        <img src="./img/icon-down.svg" className={`mr-4 w-[24px] ${isOpen ? "" : "rotate-180"}`} />
      </button>
      <div className="flex items-center space-x-4">
        <ObjectListHeaderToggleButton
          label={t("heavy_machine")}
          isActive={target === "machine"}
          onClick={() => {
            onChangeTarget("machine");
          }}
        />
        <span>【</span>
        <ObjectListHeaderToggleButton
          label={t("all")}
          isActive={machineStatus === "all"}
          onClick={() => {
            onChangeTarget("machine");
            onFilterMachineStatus("all");
          }}
          isInactive={target !== "machine"}
        />
        <ObjectListHeaderToggleButton
          label={t("in_operation")}
          isActive={machineStatus === "inOperation"}
          onClick={() => {
            onChangeTarget("machine");
            onFilterMachineStatus("inOperation");
          }}
          isInactive={target !== "machine"}
        />
        <ObjectListHeaderToggleButton
          label={t("waiting")}
          isActive={machineStatus === "waiting"}
          onClick={() => {
            onChangeTarget("machine");
            onFilterMachineStatus("waiting");
          }}
          isInactive={target !== "machine"}
        />
        <span>】</span>
        <ObjectListHeaderToggleButton
          label={t("other")}
          isActive={target === "other"}
          onClick={() => onChangeTarget("other")}
        />
      </div>
    </div>
  );
};
